"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationsDeleteSlice = void 0;
const api_1 = require("../../api/index.js");
const name_1 = require("../name.js");
const remove_1 = require("../@sync/remove.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
exports.notificationsDeleteSlice = (0, xuder_1.createDeleteAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: (0, sonar_analytics_1.createLogSaga)(sonar_analytics_1.AMPLITUDE_EVENT.NOTIFICATIONS_CLEARED),
            type: xuder_1.SagaYieldType.Every
        }
    ],
    httpSagaOptions: {
        preRequestActionCreators: [remove_1.removeNotifications.syncActionCreator]
    },
    name: name_1.NotificationsName,
    receive: false,
    request: false,
    requestHandler: api_1.deleteNotifications
});
//# sourceMappingURL=delete.js.map